import { Component, OnInit } from "@angular/core";
import { ServicesService } from "../services/services.service";
import { Router } from "@angular/router";
import { environment } from "../../environments/environment";
import swal from "sweetalert2";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";

@Component({
  selector: "app-maintenance",
  templateUrl: "./maintenance.component.html",
  styleUrls: ["./maintenance.component.css"],
})
export class MaintenanceComponent implements OnInit {
  fields: any = [];
  listData: any = [];

  MaintenanceJob: any = {};
  listMaintenanceJobIds: number[] = [];

  public loading = false;
  isLoader: boolean = false;
  public show: boolean = false;
  apiBaseUrl = environment.apiBaseUrl;
  spinLoader = {
    filter: false,
    delete: [],
  };
  addProjectOrderForm: FormGroup;
  employeeList = [];
  deactivate: FormGroup;
  isListData = true;
  isOnePage = false;
  route: string;
  isListDataEmpty = false;
  apiUrl = environment.apiUrl;
  maintenancetId: any;

  listMaintenanceJobs: any = [];
  selectedMaintenanceJobs: any = [];

  constructor(private _services: ServicesService, private router: Router) {}

  ngOnInit() {
    this._services.checkToken("status");

    this.getPageRequest();
    const token = localStorage.getItem("userToken");
    this.fields = [
      {
        field: "municipality_center",
        title: "Municipality Center",
        width: "40%",
        code: false,
        sort: true,
      },
      // {
      //   'field' : 'ward',
      //   'title' : 'Ward',
      //   'width' : '25%',
      //   'code'  : false,
      //   'sort'  : true
      // },
      {
        field: "client_name",
        title: "Client Name",
        width: "40%",
        code: false,
        sort: true,
      },
    ];
    this.searchFields["project_type"] = "";
    this.addProjectOrderForm = new FormGroup({
      // municipality_center: new FormControl("", [Validators.required]),
      // 'ward': new FormControl('', [Validators.required]),
      // client_name: new FormControl("", [Validators.required]),
      // address: new FormControl("", [Validators.required]),
      // employee: new FormControl("", [Validators.required]),
      job_type: new FormControl("", [Validators.required]),
      frequency: new FormControl("", [Validators.required]),
      description: new FormControl("", [Validators.required]),
    });
    this.deactivate = new FormGroup({
      is_active: new FormControl(0)
    })
  }

  resetSearchField() {
    this.spinLoader["filter"] = true;
    this.searchFields = [""];
    this.getPageRequest();
  }

  getSearchRequest() {
    this.spinLoader["filter"] = true;
    this.getPageRequest();
  }

  status: any;

  // deleteProject(id){
  //   this.status = confirm("Are You Sure");
  //   if(this.status){
  //     this.route = 'delete-project';
  //     let token = this._services.getToken();
  //     var data = {
  //       'id':id,
  //       page  : this.currentPage,
  //       search: {
  //         'project_name' : this.searchFields['project_name'],
  //       },
  //       sort  : this.sortingData
  //     };
  //     this._services.postRequest(data,this.route,token).subscribe((data: any) => {
  //       swal({
  //         title: 'Deleted.',
  //         text: data.message,
  //         type: 'success',
  //         showCancelButton: false,
  //         confirmButtonColor: 'rgb(17, 205, 239)',
  //         cancelButtonColor: 'rgb(245, 54, 92)',
  //         confirmButtonText: 'Yes'
  //       }).then(() => {
  //         this.listData = data.result;
  //         this.paginate = data.paginate;
  //         this.getPages(this.paginate.last_page);
  //       })
  //     });
  //   }
  // }

  sortType: string = "";
  sortField: string = "";
  oldField: string;
  sortingData = {
    field: "",
    type: "",
  };

  sortBy(field, event) {
    this.spinLoader["filter"] = true;
    this.oldField = this.oldField != field ? this.oldField : field;

    if (typeof this.oldField !== "undefined") {
      ////console.log(document.getElementById('fa-'+this.oldField));
      document
        .getElementById("fa-" + this.oldField)
        .classList.remove("fa-sort-up");
      document
        .getElementById("fa-" + this.oldField)
        .classList.remove("fa-sort-down");
      document.getElementById("fa-" + this.oldField).classList.add("fa-sort");
    }

    event.target.classList.add("fa");

    this.sortField = field;
    this.sortType = this.sortType == "desc" ? "asc" : "desc";

    switch (this.sortType) {
      case "desc":
        {
          event.target.classList.remove("fa-sort-up");
          event.target.classList.add("fa-sort-down");
          this.oldField = field;
        }
        break;
      case "asc":
        {
          event.target.classList.remove("fa-sort-down");
          event.target.classList.add("fa-sort-up");
          this.oldField = field;
        }
        break;
      default: {
        event.target.classList.add("fa-sort");
      }
    }

    this.sortingData = {
      field: this.sortField,
      type: this.sortType,
    };

    this.getPageRequest();
  }
  /*------------------------------Table with Sorting Ends Here--------------------------*/

  /*------------------------------Pagination Integration Starts Here------------------------*/
  currentPage: number = 1;
  loader: boolean = false;
  paginate = {
    last_page: 1,
  };
  searchFields = [];
  pages: any;
  //   listData = [];
  editData: Object = {};

  previousPage() {
    if (this.currentPage == 1) {
      return;
    }

    this.currentPage = this.currentPage - 1;
    ////console.log(this.currentPage);return;
    this.getPageRequest();
  }

  nextPage() {
    if (this.paginate.last_page - 1 < this.currentPage) {
      return;
    }

    this.currentPage++;
    ////console.log(this.currentPage);
    this.getPageRequest();
  }

  changePage() {
    this.currentPage = this.currentPage;
    ////console.log(this.currentPage);return;
    this.getPageRequest();
  }

  getPages(n) {
    if (n > 1) {
      this.isOnePage = true;
    } else {
      this.isOnePage = false;
    }
    var data = [];
    for (var i = 1; i <= n; i++) {
      data.push(i);
    }
    this.pages = data;
  }

  /*------------------------------Pagination Integration Starts Here------------------------*/
  routeData: string;
  totalData: any;
  getPageRequest() {
    let data;
    this.routeData = "v2/get-maintenance-web";
    switch (this.routeData) {
      case "v2/get-maintenance-web": {
        data = {
          page: this.currentPage,
          search: {
            municipality: this.searchFields["municipality"],
            project_type: this.searchFields["project_type"],
          },
          sort: this.sortingData,
        };
        break;
      }
    }

    this.loading = true;
    const token = localStorage.getItem("userToken");
    this._services
      .requestCreator(data, this.routeData, token)
      .subscribe((result: any) => {
        result = result.result;
        if (this._services.checkToken(result.result.status)) {
          this.spinLoader["filter"] = false;
          this.isListData = false;

          this.listData = [];
          this.listData = result.result;
          console.log("Maintenance Jobs", this.listData);
          this.totalData = result.paginate.total;
          this.currentPage = result.paginate.current_page;

          if (this.listData.length == 0) {
            this.isListDataEmpty = true;
          } else {
            this.isListDataEmpty = false;
          }
          this.paginate = result.paginate;

          if (result.paginate.current_page > result.paginate.last_page) {
            this.currentPage = result.paginate.last_page;
          }

          this.getPages(this.paginate.last_page);

          for (let key in this.spinLoader) {
            if (key == "delete") {
              this.spinLoader[key] = [];
            } else {
              this.spinLoader[key] = false;
            }
          }
        }
      });

    return true;
  }

  projectData = {
    municipality_center: "",
    // 'ward':'',
    client_name: "",
    description: "",
    address: "",
    employee: "",
    project_type: "",
    job_type: "",
    frequency: "",
    maintenance_job_ids: "",
  };

  Show(maintenanceData) {
    this.routePath = "get-employee-names"; // it also update project order
    this._services
      .requestCreator(
        this.addProjectOrderForm.value,
        this.routePath,
        this._services.getToken()
      )
      .subscribe((data: any) => {
        this._services.checkToken(data.status);
        if (data.status == "200") {
          this.employeeList = data.result;
        }
      });

    this.projectData = maintenanceData;
    this.selectedMaintenanceJobs = this.projectData;
    this.setProjectDataToLocalStorage();
    // console.log("data", this.projectData);
    this.MaintenanceJob = this.projectData;
    this.show = true;
    this.maintenancetId = maintenanceData.id;
    this.fetchMaintenanceJobs(maintenanceData.maintenance_job_ids);

    // Set the maintenance job ID to local storage
    localStorage.setItem("selectedMaintenanceId", this.maintenancetId);

    this.addProjectOrderForm.patchValue({
      // employee: maintenanceData.employee,
      // address: maintenanceData.address,
      // client_name: maintenanceData.client_name,
      // municipality_center: maintenanceData.municipality_center,
      description: maintenanceData.description,
      // project_type: maintenanceData.project_type,
      job_type: maintenanceData.job_type,
      frequency: maintenanceData.frequency,
    });

    console.log("Maintenace ID: ", this.maintenancetId);
  }

  setProjectDataToLocalStorage() {
    localStorage.setItem("projectData", JSON.stringify(this.projectData));
    localStorage.setItem(
      "selectedMaintenanceJobs",
      JSON.stringify(this.selectedMaintenanceJobs)
    );
  }

  navigate(job: any) {
    if (job && job.id) {
      // Setting the selected maintenance job object to local storage
      localStorage.setItem("selectedMaintenanceData", JSON.stringify(job));

      this.router.navigate(["/maintenance-history"]);
    } else {
      console.error("Invalid job data:", job);
    }
  }

  fetchMaintenanceJobs(job_id) {
    this.routePath = "v2/list-maintenance-job";
    const token = localStorage.getItem("userToken");
    const data = {
      job_ids: job_id,
    };

    if (!job_id) {
      this.listMaintenanceJobs = [];
      return;
    }

    console.log("jobs", job_id);
    this._services
      .requestCreator(data, this.routePath, token)
      .subscribe((result: any) => {
        if (this._services.checkToken(result.status)) {
          // Assuming result.result contains the list of maintenance jobs
          this.listMaintenanceJobs = result.result;
          console.log(this.listMaintenanceJobs);

          // // Convert maintenance_job_ids from string to array
          // const maintenanceJobIdsArray = JSON.parse(
          //   this.MaintenanceJob.maintenance_job_ids
          // );

          // Filter jobs based on maintenance_job_ids
          // this.listMaintenanceJobs = this.listMaintenanceJobs

          console.log("Filtered Maintenance Jobs:", this.listMaintenanceJobs);
        }
      });
  }

  back() {
    this.show = false;
  }

  isFormSubmitted = false;
  showloader = false;
  routePath;

  // convenience getter for easy access to form fields
  get f() {
    return this.addProjectOrderForm.controls;
  }

  updateOrderProject(id = null, isdelete = null) {
    //console.log(this.addProjectOrderForm.value);

    this.addProjectOrderForm.value["id"] = id ? id : this.maintenancetId;

    this.isFormSubmitted = true;
    this.showloader = true;

    // if ((this.f.employee.errors) && (isdelete = null)) {
    //     this.showloader = false;
    //     return;
    //   }

    this.routePath = "v2/create-maintenance"; // it also update maintainance employee
    this._services
      .requestCreator(
        this.addProjectOrderForm.value,
        this.routePath,
        this._services.getToken()
      )
      .subscribe((data: any) => {
        this._services.checkToken(data.status);
        if (data.status == "200") {
          this.showloader = false;
          this.isFormSubmitted = false;
          swal({
            title: "Maintenance",
            text: "Maintenance Updated Successfully",
            type: "success",
            showCancelButton: false,
            confirmButtonColor: "rgb(17, 205, 239)",
            cancelButtonColor: "rgb(245, 54, 92)",
            confirmButtonText: "Yes",
          }).then(() => {
            this.getPageRequest();
          });
        } else {
          this.showloader = false;
          this.isFormSubmitted = false;
        }
      });
  }

  deactivateMaintenance(id = null, isdelete = null) {
    //console.log(this.addProjectOrderForm.value);

    this.deactivate.value["id"] = id ? id : this.maintenancetId;

    this.isFormSubmitted = true;
    this.showloader = true;

    // if ((this.f.employee.errors) && (isdelete = null)) {
    //     this.showloader = false;
    //     return;
    //   }

    this.routePath = "v2/create-maintenance"; // it also update maintainance employee
    this._services
      .requestCreator(
        this.deactivate.value,
        this.routePath,
        this._services.getToken()
      )
      .subscribe((data: any) => {
        this._services.checkToken(data.status);
        if (data.status == "200") {
          this.showloader = false;
          this.isFormSubmitted = false;
          swal({
            title: "Maintenance",
            text: "Maintenance Updated Successfully",
            type: "success",
            showCancelButton: false,
            confirmButtonColor: "rgb(17, 205, 239)",
            cancelButtonColor: "rgb(245, 54, 92)",
            confirmButtonText: "Yes",
          }).then(() => {
            this.getPageRequest();
          });
        } else {
          this.showloader = false;
          this.isFormSubmitted = false;
        }
      });
  }

  deleteMaintenance(id) {
    swal({
      title: "Are you sure?",
      text: "Do you want delete maintenance?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#163862",
      confirmButtonText: "Yes",
      cancelButtonColor: "rgb(245, 54, 92)",
    }).then((result) => {
      // alert(result.value);
      if (result.value === true) {
        this.addProjectOrderForm.value["is_active"] = 0;
        ////console.log(this.addProjectOrderForm);
        this.updateOrderProject(id, "true");
      }
    });
  }
}
